var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 10.323V20.0072C0.625 20.6566 1.15456 21.2035 1.83268 21.2377C4.05755 21.3516 8.83724 21.8119 11.5625 23.6622V11.5079C8.89193 9.69861 4.27038 9.21098 1.9849 9.08337C1.24434 9.04236 0.625 9.61202 0.625 10.323ZM22.6003 9.08337C20.3175 9.21317 15.7051 9.69724 13.071 11.5028C13.0254 11.5079 13.0208 11.5124 13.0208 11.5215V23.6667C15.757 21.826 20.5267 21.3534 22.7507 21.2386C23.4297 21.2012 23.9583 20.6543 23.9583 20.0072V10.323C23.9583 9.61202 23.3385 9.04236 22.6003 9.08337ZM16.6667 4.70837C16.6667 2.29301 14.707 0.333374 12.2917 0.333374C9.8763 0.333374 7.91667 2.29301 7.91667 4.70837C7.91667 7.12374 9.8763 9.08337 12.2917 9.08337C14.707 9.08337 16.6667 7.12374 16.6667 4.70837Z",
    fill: "#0767FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolActive);
export default __webpack_public_path__ + "static/media/school-active.4248c81eb96442ba6c3fd6979fabe1ea.svg";
export { ForwardRef as ReactComponent };